import {
  HelpCircle,
  Lock,
  Clock,
  Database,
  Phone,
  Settings,
  Zap,
} from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import Button from './Button';

export default function Faq() {
  const { t } = useTranslation();

  const faqs = [
    {
      icon: Lock,
      question: t('faqHipaaQuestion'),
      answer: t('faqHipaaAnswer'),
    },
    {
      icon: Clock,
      question: t('faqSetupQuestion'),
      answer: t('faqSetupAnswer'),
    },
    {
      icon: Database,
      question: t('faqImportQuestion'),
      answer: t('faqImportAnswer'),
    },
    {
      icon: Phone,
      question: t('faqSupportQuestion'),
      answer: t('faqSupportAnswer'),
    },
    {
      icon: Settings,
      question: t('faqCustomizeQuestion'),
      answer: t('faqCustomizeAnswer'),
    },
    {
      icon: Zap,
      question: t('faqTrialQuestion'),
      answer: t('faqTrialAnswer'),
    },
  ];

  return (
    <section className="py-20 px-4 lg:px-8 bg-gray-50/50">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-gray-100 px-4 py-1 rounded-full text-sm mb-4">
            <HelpCircle className="w-4 h-4" />
            FAQ
          </div>
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">
            {t('faqTitle')}
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            {t('faqSubtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8 auto-rows-auto">
          {faqs.map((faq, index) => {
            const Icon = faq.icon;
            return (
              <div
                key={index}
                className="bg-white rounded-xl border transition-all hover:shadow-lg h-fit"
              >
                <Accordion type="single" collapsible>
                  <AccordionItem
                    value={`item-${index}`}
                    className="border-none"
                  >
                    <AccordionTrigger className="px-6 py-4 hover:no-underline group">
                      <div className="flex items-center gap-3 text-left">
                        <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center">
                          <Icon className="w-5 h-5 text-primary-500" />
                        </div>
                        <span className="font-semibold text-base group-hover:text-gray-600 transition-colors">
                          {faq.question}
                        </span>
                      </div>
                    </AccordionTrigger>
                    <AccordionContent className="px-6 pb-4 pt-0 h-fit">
                      <div className="pl-[52px]">{faq.answer}</div>
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              </div>
            );
          })}
        </div>

        <div className="mt-12 text-center">
          <p className="text-muted-foreground mb-4">
            {t('stillHaveQuestions')}
          </p>
          <Button variant="outline" size="lg">
            {t('contactSupport')}
          </Button>
        </div>
      </div>
    </section>
  );
}
